/**
 * 予測共通関数
 *
 * @author hayakawa 2023.10.18
 */

// インポート
import { $spinner } from '../_constants';

// 定数
const $flash_message = $('#flash-message'),
    $form_predict = $('#form-predict');

/**
 * 予測データを保存
 *
 * @returns {void}
 * @author hayakawa 2023.10.18
 */
export const savePredict = () => {
    const $form_data = new FormData($form_predict.get(0)),
        params = new URLSearchParams($form_data),
        $btn = $('button'),
        btn_html = $('#save_predict').html();

    $btn.prop('disabled', true);
    $('#save_predict').html($spinner);
    axios.post(VALIDATE_STORE_PREDICT_API_ENDPOINT, params)
    .then(res => {
        $form_predict.find('.is-invalid').removeClass('is-invalid');
        $form_predict.find('.invalid-feedback').text('');
        $flash_message.find('.exec-result-message').hide();
        $flash_message.find('.auto-show-hide').hide();
        $form_predict.trigger('submit');
    })
    .catch(err => {
        const errors = err.response.data.errors;
        console.log(errors);
        let html = `<ul>\n`;
        $form_predict.find('.is-invalid').removeClass('is-invalid');
        $form_predict.find('.invalid-feedback').text('');
        $.each(errors, function(k, v) {
            const keys = k.split('.'),
                input_name = keys[0],
                input_eq = keys[1],
                id = $form_predict.find(`[name="${input_name}[${input_eq}]"]`).attr('id');
            $form_predict.find(`[name="${input_name}[${input_eq}]"]`).addClass('is-invalid');
            $form_predict.find(`[name="${input_name}[${input_eq}]"]`).next().text(v);
            if (id === undefined) {
                html += `<li>${v}</li>\n`;
            } else {
                html += `<li><a href="#${id}" class="alert-link">${v}</a></li>\n`;
            }
        })
        html += `</ul>\n`;
        $flash_message.find('.exec-result-message').html(html).show();
    })
    .finally(() => {
        $('#save_predict').html(btn_html);
        $btn.prop('disabled', false);
    })
};
